import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { IInventoryCategoryType } from "./types";

type Props = {
  inventoryCategories: IInventoryCategoryType[];
};

export const InventoryCategoryViewer = ({ inventoryCategories }: Props) => {
  if (inventoryCategories?.length === 0) {
    return null;
  }
  return (
    <div>
      {inventoryCategories?.map((i) => {
        return (
          <Flex key={i._id} alignItems="center" gap={"4px"}>
            <img
              src={i.icon}
              alt="inventory category"
              style={{ height: "24px", width: "24px" }}
            />
            <Typography size="title" color="dark.black">
              {i?.title}
            </Typography>
          </Flex>
        );
      })}
    </div>
  );
};
